import { Injectable } from '@angular/core';
import { SettingsService } from '../services/indexed-db/object-stores/settings/settings.service';
import { RouteSettings } from '../services/indexed-db/object-stores/settings/settings';

export const defaultCarParkingTimeInMinutes = 8;
export const defaultBikeParkingTimeInMinutes = 3;
export const defaultMaximumTourLengthInHours = 10;
export const defaultTimePerLeadInMinutes = 7;

@Injectable({
  providedIn: 'root',
})
export class RouteSettingsService {
  private settings: RouteSettings = {
    carParkingTimeInMinutes: defaultCarParkingTimeInMinutes,
    bikeParkingTimeInMinutes: defaultBikeParkingTimeInMinutes,
    maximumTourLengthInHours: defaultMaximumTourLengthInHours,
    timePerLeadInMinutes: defaultTimePerLeadInMinutes,
  };

  constructor(private settingsService: SettingsService) {}

  initialize() {
    this.settingsService.getRouteSettings().then((routeSettings) => {
      if (routeSettings) {
        this.settings = routeSettings;
      }
    });
  }

  private updateSettings() {
    this.settingsService.setRouteSettings(this.settings);
  }

  getCarParkingTimeInMinutes() {
    return this.settings.carParkingTimeInMinutes;
  }

  getBikeParkingTimeInMinutes() {
    return this.settings.bikeParkingTimeInMinutes;
  }

  getMaximumTourLengthInHours() {
    return this.settings.maximumTourLengthInHours;
  }

  getTimePerLeadInMinutes() {
    return this.settings.timePerLeadInMinutes;
  }

  setCarParkingTimeInMinutes(carParkingTimeInMinutes: number) {
    this.settings.carParkingTimeInMinutes = carParkingTimeInMinutes;
    this.updateSettings();
  }

  setBikeParkingTimeInMinutes(bikeParkingTimeInMinutes: number) {
    this.settings.bikeParkingTimeInMinutes = bikeParkingTimeInMinutes;
    this.updateSettings();
  }

  setMaximumTourLengthInHours(maximumTourLengthInHours: number) {
    this.settings.maximumTourLengthInHours = maximumTourLengthInHours;
    this.updateSettings();
  }

  setTimePerLeadInMinutes(timePerLeadInMinutes: number) {
    this.settings.timePerLeadInMinutes = timePerLeadInMinutes;
    this.updateSettings();
  }
}
